'use es6';

import { fromJS, Map as ImmutableMap, Record } from 'immutable';
import { RequestStatus } from '../constants/base';
const DEFAULTS = {
  data: ImmutableMap(),
  status: RequestStatus.UNINITIALIZED
};
export default class Settings extends Record(DEFAULTS) {
  static fromJS(data) {
    return new Settings({
      data: fromJS(data),
      status: RequestStatus.SUCCEEDED
    });
  }

}